import {Component, model} from '@angular/core';
import {TenderPhaseType} from '@frontend/shared-api';
import {DropdownFilterComponent} from '../../../../../shared/components/filter/dropdown-filter/dropdown-filter.component';
import {FILTER_ALL, PHASE_FILTER_ARCHIVED} from './dropdown-phase-filter.types';

@Component({
  selector: 'app-dropdown-phase-filter',
  templateUrl: './dropdown-phase-filter.component.html',
  imports: [DropdownFilterComponent],
})
export class DropdownPhaseFilterComponent {
  value = model.required<string>();

  protected readonly options: {label: string; value: string}[] = [
    {label: 'common.all', value: FILTER_ALL},
    ...Object.values(TenderPhaseType).map((phase: TenderPhaseType) => ({
      label: phase,
      value: phase,
    })),
    {label: 'project.status.archived', value: PHASE_FILTER_ARCHIVED},
  ];
}
